module.exports = __webpack_public_path__ + "img/sage-2.1813b062.webp";